import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: '"I had been taking ibuprofen every morning for 3 years. On day 4 of the protocol I realized I hadn\'t needed it. I cried with emotion."',
  name: 'Carmen R.',
  age: '62 years old',
  city: 'Miami, FL',
  initials: 'CR'
}, {
  quote: '"My doctor told me it was normal wear and tear. I decided to try this anyway. After 7 days I showed my knees to my daughter and we were both surprised. The swelling had noticeably gone down."',
  name: 'Patricia M.',
  age: '68 years old',
  city: 'Houston, TX',
  initials: 'PM'
}, {
  quote: '"What impressed me most was understanding WHY it hurt. Nobody had explained the connection between the gut and the joints to me. Now I understand it and know exactly what to do."',
  name: 'Rosa Elena V.',
  age: '57 years old',
  city: 'Los Angeles, CA',
  initials: 'RV'
}, {
  quote: '"I spent more than $200 a month for 2 years on supplements. This protocol costs me $12 a week and works better than everything I tried before."',
  name: 'Miriam T.',
  age: '71 years old',
  city: 'New York, NY',
  initials: 'MT'
}];
export function Testimonials() {
  return <section className="bg-cream py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <FadeIn data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-black mb-16" data-id="element-217">
            What Women Who Already Tried It Are Saying:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-218">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-219">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col" data-id="element-220">
                <div className="flex gap-1 mb-6" data-id="element-221">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-222" />)}
                </div>

                <p className="font-serif italic text-lg text-gray-700 mb-8 flex-grow" data-id="element-223">
                  {testimonial.quote}
                </p>

                <div className="flex items-center gap-4 mt-auto" data-id="element-224">
                  <div className="w-12 h-12 rounded-full bg-sage-light/30 flex items-center justify-center text-forest-green font-bold text-lg" data-id="element-225">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-226">
                    <p className="font-bold text-gray-900" data-id="element-227">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-228">
                      {testimonial.age}, {testimonial.city}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}